import React from "react";
import styles from "../../assets/scss/pagesScss/home.module.scss"; // SCSS styles
import { aboutData } from "../../assets/config/config";
import { Link } from "react-router-dom"; // If using React Router

export default function AboutSections() {
    return (
        <section className={styles.aboutSection}>
            <div className="container">
                {/* Left Side - Image with Experience Box */}
                <div className={styles.at_wrp}>
                    <div className={styles.imageContainer}>
                        <img src={aboutData.image} alt="About Us" className={styles.aboutImage} />
                        <div className={styles.experienceBox}>
                            <span className={styles.experienceYears}>{aboutData.experience.years}</span>
                            <span className={styles.experienceText}>{aboutData.experience.text}</span>
                        </div>
                    </div>

                    {/* Right Side - Content */}
                    <div className={styles.contentContainer}>
                        <span className={styles.subtitle}>{aboutData.subtitle}</span>
                        <h2 className={styles.title}>{aboutData.title}</h2>
                        {aboutData.description.map((paragraph, index) => (
                            <p key={index} className={styles.description}>
                                {paragraph}
                            </p>
                        ))}

                        <Link to={aboutData.button.link} className={styles.moreInfoButton}>
                            {aboutData.button.text} <i className='fa fa-right-arrow'></i>
                        </Link>
                    </div>
                    <img className={styles.span_img} src="/images/aboutspan.png" alt="About Us" />
                </div>
            </div>
        </section>
    );
}
